import React, { Fragment } from 'react';
import { cnMerge } from '../../../../utils/utils';
import { Typography } from '../../../atoms/typography/Typography';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

export const HtmlTextSection = ({ section, className, textClassName }) => {
  const isList = section?.componentData && section.componentData.length > 0;

  return (
    <div
      className={cnMerge(
        className,
        'flex w-full flex-col flex-1 px-8 lg:mx-auto my-5 max-w-6xl'
      )}
    >
      {isList ? (
        section.componentData?.map((item) => (
          <Fragment key={item.title}>
            <Typography as="h2" textAlign="left" fontVariant="h4">
              {item.title}
            </Typography>
            <StyledHtmlDiv className={textClassName} content={item.text} />
          </Fragment>
        ))
      ) : (
        <StyledHtmlDiv className={textClassName} content={section} />
      )}
    </div>
  );
};
